<template>
    <v-container colum fluid fill-height>
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        <v-icon left>mdi-package-variant-closed</v-icon>Warehouse
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="hidden-sm-and-down">
                        <AddWarehouse @added="getList" />
                    </v-toolbar-items>
                    </v-toolbar>
                    <v-data-table
                        :headers="headers"
                        :items="list"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="totalCount"
                        >
                        <template v-slot:item.actions="{item}">
                            <v-btn text icon :to="'/inventory/warehouse/'+item.id">
                                <v-icon small>mdi-package-variant-closed</v-icon>
                            </v-btn>
                            <EditWarehouse :warehouse="item" @saved="getList" />
                            <DeleteWarehouse :warehouse="item" @saved="getList" />
                        </template>
                        <template v-slot:item.external="{item}">
                            {{item.external ? 'Yes':'No'}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import AddWarehouse from '@components/warehouse/Add'
import EditWarehouse from '@components/warehouse/Edit'
import DeleteWarehouse from '@components/warehouse/Delete'
export default {
    components:{
        AddWarehouse,
        EditWarehouse,
        DeleteWarehouse
    },
    data: () => ({
        list:[],
        loading:true,
        headers: [
            { text: "Code", value: "code", align: "left" },
            { text: "Name", value: "name", align: "left" },
            { text: "Is External ?", value: "external" },
            { text: "Actions", value: "actions", sortable: false }
        ],
        options: { itemsPerPage: 20 },
        totalCount:0
    }),
    mounted(){
        this.getList()
    },
    methods:{
        ...mapActions("warehouse", {listWarehouse:"list"}),
        getList(){
            this.listWarehouse()
            .then(({warehouses}) => {
                this.list = warehouses.data
                this.totalCount=warehouses.total
            })
            .finally(() => {
                this.loading=false
            })
        }
    }
    
}
</script>

<style>

</style>